





























import { Component, Vue } from "vue-property-decorator";
import { AuthService } from "@/services/auth/auth.service";
import { mixins } from "vue-class-component";
import Loader from "@/resources/mixins/loader/loader";
import { i18n } from "@/resources/locales";
@Component({
  name: "error-general-client-graphic-component",
})
export default class ErrorGeneralClientGraphicComponent extends mixins(
  Vue,
  Loader
) {
  messageError = "";
  mounted(): void {
    this.stopLoader(this.$store);
    this.messageError =
      this.$store.getters["SystemStore/getErrorDataGeneralClientGraphic"];
  }
  get active() {
    return this.$store.getters["SystemStore/getErrorGeneralClientGraphic"];
  }
  set active(e) {
    this.$store.dispatch("SystemStore/setErrorGeneralClientGraphicAction", e);
  }
  async reload() {
    this.active = false;
    window.location.reload();
  }
  async cleanAndStart() {
    const _authService = new AuthService();
    _authService.logOut();
  }
  async sendReport() {
    /*this.startLoader(this.$store);
    let data = {
      type: "GRAPHIC_CLIENT",
      errorMessage: this.messageError,
      userMessage: ""
    }
    this.$store.dispatch("LogsStore/sendGraphicClientErrorAction", {
      data: data,
      callback: (response) => {
        this.stopLoader(this.$store);
        this.$vs.notification({
          color: "success",
          title: i18n.t("notifications.titles.success"),
          text: i18n.t("notifications.descriptions.sendReport"),
        });
      },
      callbackError: (error) => {
        this.stopLoader(this.$store);
        this.$vs.notification({
          title: i18n.t("notifications.titles.error"),
          text: i18n.t("notifications.genericError.genericErrorRetry"),
        });
      },
    });*/
  }
}
